import $ from "jquery";
import uly from "ulysses/core";
import ko from "knockout";
import HalResource from "ulysses/api";
import {choose_template} from "./choose_template";

export function compose_sms(bound_entity, default_recipient) {
    choose_template(bound_entity, "sms").then(function (template) {
        if (!template) {
            uly.utils.show_results({
                "success": false,
                "error": _("communications_no_template_for_sms", "No templates have been defined for SMS")
            });
            return;
        }
        let newsms_resource = HalResource(bound_entity).follow("uly:communications").follow("uly:newsms", {
            "template": template,
            "context": bound_entity.unique_id,
            "recipient": default_recipient
        });
        newsms_resource.then(function (result) {
            uly.dialogs.execute(result.dialog_markup, {
                "title": _("communications_title_compose_sms", "Compose sms")
            }, $.extend({
                "recipient": null,
                "title": null,
                "document": null
            }, result.message_data))
                .then(function ([result]) {
                    newsms_resource.post(null, ko.toJS(result)).always(uly.utils.show_results).done(function (result) {
                        //posted...
                        uly.publish("entity.modified", bound_entity);
                    });
                });
        });
    });
};

export function compose_message(bound_entity, default_recipient) {
    choose_template(bound_entity, "email").done(function (template) {
        if (!template) {
            uly.utils.show_results({
                "success": false,
                "error": _("communications_no_template_for_email", "No templates have been defined for email")
            });
            return;
        }
        let newmessage_resource = HalResource(bound_entity).follow("uly:communications").follow("uly:newmessage", {
            "template": template,
            "context": bound_entity.unique_id,
            "recipient": default_recipient
        });
        newmessage_resource.then((result) => {
            uly.dialogs.execute(result.dialog_markup, {
                "title": _("communications_title_compose_message", "Compose Message"),
                "buttons": {
                    "cancel": {
                        "caption": _("communications_compose_message_cancel", "Cancel"),
                        "button_class": "pull-left btn",
                        "icon": "fa fa-times-circle",
                        "action": "closedialog"
                    },
                    "ok": {
                        "caption": _("communications_compose_message_ok", "Ok"),
                        "button_class": "btn btn-primary",
                        "icon": "fa fa-check-circle",
                        "action": "closedialog"
                    },
                    "preview": {
                        "caption": _("communications_compose_message_preview", "Preview"),
                        "button_class": "btn btn-success",
                        "icon": "fa fa-eye",
                        "action": "previewdocument"
                    },
                }
            }, $.extend({
                "recipient": null,
                "title": null,
                "document": null,
                "cc": null,
                "bcc": null
            }, result.message_data))
                .then(([result]) => {
                    newmessage_resource.post(null, ko.toJS(result)).always(uly.utils.show_results).then((_result) => {
                        //posted...
                        uly.publish("entity.modified", bound_entity);
                    });
                });
        });
    });
};

